import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './Icon.module.scss';
import ICONS from '../../static/media/icons/icons-helper';

const Icon = ({ name, containerStyle, svgExtendedStyle }) => {
  return (
    <div className={classnames(styles.iconContainer, containerStyle)}>
      <img
        className={classnames(styles.svg, svgExtendedStyle)}
        src={ICONS[name]}
        alt="icon-img"
      />
    </div>
  );
};

Icon.propTypes = {
  name: PropTypes.string.isRequired,
  containerStyle: PropTypes.any,
  svgExtendedStyle: PropTypes.any,
};

Icon.defaultProps = {
  containerStyle: null,
  svgExtendedStyle: null,
};

export default Icon;
